import React,  { useState, useEffect } from "react";
import { useStateValue } from '../../context/store';
import { useForm } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { 
  Grid, 
  TextField, 
  FormControl, 
  Button, 
  Typography, 
  InputLabel, 
  Select, 
  FormHelperText
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { styles } from '../styles';
import Snackbars from "../../componentes/snackbars/SnackBars";
import { save, getById } from '../../actions/generic-actions';
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";

const defaultValues = {
  code: '',
  description: '',
  categoryStatus: '',
  categoryType: '',
  creationUser: ''
};

const CategoriesForm = (props) => {
  const [, dispatch] = useStateValue();
  const { id } = props.match.params;
  const isAddMode = !id;

  const classes = styles();
  const [messageOpen, setMessageOpen] = useState(false);
  const [category, setCategory] = useState([]);
  const [message, setMessage] = useState({
    open: false,
    text: '',
    type: '',
    fontColor:''
  });

  const schema = yup.object().shape({
    code: yup.string().required(REQUIRED_MESSAGE),
    description: yup.string().required(REQUIRED_MESSAGE),
    categoryStatus: yup.string().required(REQUIRED_MESSAGE),
    categoryType: yup.string().required(REQUIRED_MESSAGE),
    creationUser: yup.string()
});
  const { register, handleSubmit, setValue, errors, } = useForm({
    resolver: yupResolver(schema),
    defaultValues
  });

  useEffect(() => {
    if (!isAddMode) {
      const getCategory = async() => {
        const categoryResponse = await getById(id);
        const fields = [
          'code',
          'description',
          'categoryStatus',
          'categoryType',
        ];
        fields.forEach(field => setValue(field, categoryResponse[field]));
        setCategory(categoryResponse);
      };
      getCategory();
    }
  }, []);


  const onSubmit = data => {
    var user = { 'creationUser' : 'DEVELOPER' };
    var newData = { ...data, ...user };
    save( newData,'/category/', dispatch).then((response) => {
      if (response && response.status === 201) {
              setMessage({
                  open: true,
                  text: 'Categoría creada exitosamente',
                  type: 'info',
                  fontColor:'#fff'
              });
              setMessageOpen(true);
              
              setTimeout(function(){ 
                props.history.goBack(); 
             }, 3000); 
          } else {
              setMessage({
                  open: true,
                  text: response.data.message,
                  type: 'warning',
                  fontColor:'#BA8A08'
              });
              setMessageOpen(true);
          }
      }, error => {
          setMessage({
              open: true,
              text: ERROR_MESSAGE,
              type: 'warning',
              fontColor:'#BA8A08'
          });
          setMessageOpen(true);
      });
  
  }

  return (
      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <Typography component='h1' variant='h4' style={{textAlign:'center'}}>
        {isAddMode ? 'Crear Categoría' : 'Editar Categoría'} 
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
          <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    InputLabelProps={{ shrink: true }} 
                    label="Código"
                    name="code"
                    margin="normal"
                    error={!!errors.hasOwnProperty("code") && errors["code"].message}
                    helperText={errors.hasOwnProperty("code") && errors["code"].message}
                />
          </FormControl>
            
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
          <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Descripción"
                    name="description"
                    InputLabelProps={{ shrink: true }} 
                    margin="normal"
                    multiline
                    rows={2}
                    rowsMax={4}
                    error={!!errors.hasOwnProperty("description") && errors["description"].message}
                    helperText={errors.hasOwnProperty("description") && errors["description"].message}
                />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <FormControl variant="outlined" fullWidth error={!!errors.hasOwnProperty("categoryStatus") && errors["categoryStatus"].message}>
              <InputLabel htmlFor="outlined-select-estado" className={classes.select}>Estado</InputLabel>
              <Select native fullWidth
                className={classes.select}
                inputRef={register}
                label = "Estado"
                margin="normal"
                name = "categoryStatus"
                InputLabelProps={{ shrink: true }} 
                inputProps = {
                    {
                        name: 'categoryStatus',
                        id: 'outlined-select-estado',
                    }
                } >
                <option aria-label = "None" value = "" />
                    <option key="ACTIVO" value="ACTIVO">ACTIVO</option>
                    <option key="INACTIVO" value="INACTIVO">INACTIVO</option>
              </Select>
              <FormHelperText>{errors.hasOwnProperty("categoryStatus") && errors["categoryStatus"].message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
          <FormControl variant="outlined" fullWidth error={!!errors.hasOwnProperty("categoryType") && errors["categoryType"].message}>
              <InputLabel htmlFor="outlined-select-tipo" className={classes.select}>Tipo</InputLabel>
              <Select native fullWidth
                className={classes.select}
                inputRef={register}
                label = "Tipo"
                margin="normal"
                name = "categoryType"
                InputLabelProps={{ shrink: true }} 
                inputProps = {
                    {
                        name: 'categoryType',
                        id: 'outlined-select-tipo',
                    }
                } >
                <option aria-label = "None" value = "" />
                <option key="RESPONSABILIDAD" value="RESPONSABILIDAD">RESPONSABILIDAD</option>
                <option key="RIESGO_INEHERENTE" value="RIESGO_INEHERENTE">RIESGO INEHERENTE</option>
              </Select>
              <FormHelperText>{errors.hasOwnProperty("categoryType") && errors["categoryType"].message}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <Button
                  type="submit"
                  fullWidth
                  variant="contained" 
                  style={{paddingTop:'16px',paddingBottom: '13px',marginTop:'16px',textTransform: "none",
                  width: "100%",
                  background: '#0f70b7',
                  color: 'white',
                  marginBottom: '20px',
                  '&:hover': 
                  {color: '#0f70b7',
                    background: '#daa900'}}}
              >
                {isAddMode ? 'CREAR' : 'EDITAR'}
            </Button>
            { messageOpen && <Snackbars severity={message.type} fontColor={message.fontColor} message={message.text}/>}
         </Grid>
        </Grid>
      </form>
    
  );
}


export default withRouter(CategoriesForm);